import { UI, Stack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

export interface PrivatePensionCardItemProps {
  label: string;
  value?: string;
  numColumns: number;
  isLoading?: boolean;
}

export const PrivatePensionCardItem: React.FC<PrivatePensionCardItemProps> = ({
  label,
  value = '',
  numColumns,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <Stack
        w={`${100 / numColumns}%`}
        maxW={`${100 / numColumns}%`}
        direction={Utils.Responsive.PhoneTablet({ phone: 'row', tablet: 'column' })}
        space={Spacing['inset.quarck']}
        justifyContent={Utils.Responsive.PhoneTablet({ phone: 'space-between', tablet: 'normal' })}>
        <UI.Text variant="semibold" color="neutral.dark">
          {label}
        </UI.Text>
        <UI.Text isLoading color="neutral.darkest" maxW="4/5" />
      </Stack>
    );
  }

  return (
    <Stack
      w={`${100 / numColumns}%`}
      maxW={`${100 / numColumns}%`}
      direction={Utils.Responsive.PhoneTablet({ phone: 'row', tablet: 'column' })}
      space={Spacing['inset.quarck']}
      justifyContent={Utils.Responsive.PhoneTablet({ phone: 'space-between', tablet: 'normal' })}>
      <UI.Text variant="semibold" color="neutral.dark">
        {label}
      </UI.Text>
      <UI.Text color="neutral.darkest">{value}</UI.Text>
    </Stack>
  );
};
